import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { getDataDashboard } from "../../services/dashboardService";

const initialState = {
      valueSearch: {
            from: dayjs().subtract(3, "month"),
            to: dayjs(),
      },
};

export const dashboardSlice = createSlice({
      name: "dashboard",
      initialState,
      reducers: {
            changeValueSearch: (state, action: any) =>
            {
                  state.valueSearch = action.payload;
            },
      },
});

export const getDataDashboardAsync = createAsyncThunk(
      "dashboard/getDataDashboard",
      async (payload: any) =>
      {
            try
            {
                  const response = await getDataDashboard(payload);
                  return response;
            } catch (e: any)
            {
                  console.log(e, "error");

                  return {
                        message: e?.response?.data?.message,
                  };
            }
      }
);

export const { changeValueSearch } = dashboardSlice.actions;

export default dashboardSlice.reducer;
